import * as SliderPrimitive from "@radix-ui/react-slider";

export const NwSlider = ({ value, max, onChange, testId, label, className = "" }) => (
  <SliderPrimitive.Root value={[value]} max={max || 1} step={0.01} onValueChange={([v]) => onChange(v)}
    aria-label={label} data-testid={testId}
    className={`group relative flex w-full touch-none select-none items-center py-2 cursor-pointer ${className}`}>
    <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden rounded-full bg-white/15">
      <SliderPrimitive.Range className="absolute h-full bg-nw-red" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block h-3.5 w-3.5 rounded-full bg-slate-100 shadow-[0_0_10px_rgba(255,30,39,0.6)] ring-2 ring-nw-red focus:outline-none" />
  </SliderPrimitive.Root>
);
